import { CSGO_Extras, Item, ShopExtraFilters } from './items.entity';
import { isCsgoExtrasShopFilter } from './utils';

export function marketNameFilterPass(marketName: string, filter: string|null): boolean {
  if(!filter) {
    return true;
  }

  return marketName.toLowerCase().includes(filter);
}

export function priceFilterPass(itemPrice: number, filter: number|null): boolean {
  if(!filter || filter <= 0) {
    return true;
  }

  return itemPrice <= filter;
}

export function onlyAvailableFilterPass(stock: number, onlyAvailable: boolean): boolean {
  if(!onlyAvailable) {
    return true;
  }

  return stock > 0;
}

export function extraFiltersPass(item: Item, extraFilters: ShopExtraFilters|null): boolean {
  if(!extraFilters) {
    return true;
  }

  if(isCsgoExtrasShopFilter(extraFilters)) {
    if(!extraFilters.type) {
      return true;
    }

    const extras = item.extra as CSGO_Extras;

    return extras.t === extraFilters.type;
  }

  return true;
}